module.exports = __webpack_public_path__ + "static/school-bus-tracking-system-446159727f4f269d1e0e694f4c2109de.jpg";